import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ArrowUp = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m6 10.769 6-6.061m0 0 6 6.06m-6-6.06v16'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M11.25 20.708V6.53l-4.717 4.765a.75.75 0 0 1-1.066-1.055l6-6.06.115-.095a.75.75 0 0 1 .951.095l6 6.06.051.057a.75.75 0 0 1-1.06 1.05l-.057-.052L12.75 6.53v14.177a.75.75 0 1 1-1.5 0'
        fill='currentColor'
      />
    )}
  </IconBase>
);
